export default {
  getIsoMidnight(date) {
    if (!date) { return date; }

    date.setUTCHours(24, 0, 0, 0);
    return date.toISOString();
  }
};